export default {
  geolocation: {
    lat: '35.6895',
    lng: '139.6917',
    label: '100-0005 Tokyo',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
